import { createUseThemeStore } from './store';

const useThemeStore = createUseThemeStore();

export default useThemeStore;
export * from './models';
